export interface FeaturePermissionInterface {
  featurePermissionId: number;
  permissionCode: string;
  permissionName: string;
  description: string;
  isEnabled: boolean;
}

export class FeaturePermission implements FeaturePermissionInterface {
  public featurePermissionId: number;
  public permissionCode: string;
  public permissionName: string;
  public description: string;
  public isEnabled: boolean;

  constructor({
    featurePermissionId = 0,
    permissionCode = '',
    permissionName = '',
    description = '',
    isEnabled = false,
  }: Partial<FeaturePermissionInterface>) {
    this.featurePermissionId = featurePermissionId;
    this.permissionCode = permissionCode;
    this.permissionName = permissionName;
    this.description = description;
    this.isEnabled = isEnabled;
  }
}
